<template>
 <div class="badges-nav page-navebar">
  <div class="bg-[#2B2C32] rounded-full  px-8 py-2 w-full min-w-fit">
    <ul class="flex flex-nowrap">
      <li :class="'mr-4 w-max flex flex-nowrap' + ($route.name == 'MembershipSetting' ? ' active' : '')">
        <router-link :to="{ name: 'MembershipSetting' }" :class="'uppercase  tracking-widest text-sm font-semibold px-2 ' + ( $route.name == 'MembershipSetting' ? 'text-white' : 'text-theme-878686 hover:text-white')">
          Membership Settings
        </router-link>
      </li>
      <li :class="'mr-4 w-max  flex flex-nowrap' + ($route.name == 'MembershipEarningPoints' ? ' active' : '')">
        <router-link :to="{ name: 'MembershipEarningPoints' }" :class="'uppercase tracking-widest text-sm font-semibold px-2 ' + ( $route.name == 'MembershipEarningPoints' ? 'text-white' : 'text-theme-878686 hover:text-white')">
          Earning
        </router-link>
      </li>
      <li :class="'mr-4 w-max  flex flex-nowrap' + ($route.name == 'MembershipRedeemingPoints' ? ' active' : '')">
        <router-link :to="{ name: 'MembershipRedeemingPoints' }" :class="'uppercase tracking-widest text-sm font-semibold px-2 ' + ( $route.name == 'MembershipRedeemingPoints' ? 'text-white' : 'text-theme-878686 hover:text-white')">
          Redeeming
        </router-link>
      </li>
      <li :class="'mr-4 w-max  flex flex-nowrap' + ($route.name == 'MembershipBadges' ? ' active' : '')">
        <router-link :to="{ name: 'MembershipBadges' }" :class="'uppercase tracking-widest text-sm font-semibold px-2 ' + ( $route.name == 'MembershipBadges' ? 'text-white' : 'text-theme-878686 hover:text-white')">
          Badges
        </router-link>
      </li>
      <li :class="' w-max  flex flex-nowrap' + ($route.name == 'MembershipFaqs' ? ' active' : '')">
        <router-link :to="{ name: 'MembershipFaqs' }" :class="'uppercase tracking-widest text-sm font-semibold px-2 ' + ( $route.name == 'MembershipFaqs' ? 'text-white' : 'text-theme-878686 hover:text-white')">
          FAQ
        </router-link>
      </li>
    </ul>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue"
import Helpers from '@/helpers';

export default defineComponent({
  name: "MembershipProgramNav",
  setup() {
    return {
      
    };
  },

  computed: {
    /**
     * Restriction based
     */
    can_view_customers_and_membership_details() {
      return Helpers.getMyPermission('can_view_customers_and_membership_details')
    },
  },
})
</script>

<style scoped>
  .active:before {
    content: '';
    position: absolute;
    background: #2BA66B;
    width: 100%;
    height: 4px;
    bottom: -11px;
  }
  .active {
    position:relative;
  }
</style>